(function () {
    'use strict';

    angular.module('app.cart', ['angular.filter','app.core', 'app.product','ngSanitize']);
})();